import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MaterialsModule } from '../materials/materials.module';
import { DateAgoPipe } from './date-ago.pipe';

@NgModule({
  declarations: [HeaderComponent, FooterComponent, DateAgoPipe],
  imports: [
    CommonModule,
    MaterialsModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
  ],
})
export class CoreModule { }
